export enum ImportModalTypes {
	FILE_SIZE = 'FILE_SIZE',
	FILE_TYPE = 'FILE_TYPE',
	DISCARD = 'DISCARD',
	PROGRESS = 'PROGRESS',
	UPLOAD_ERROR = 'UPLOAD_ERROR',
	PROCESS_ERROR = 'PROCESS_ERROR',
	BULK_LIMIT = 'BULK_LIMIT',
	STRICT_FORMAT_ERROR = 'STRICT_FORMAT_ERROR',
	PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
	RESTRICTION = 'RESTRICTION',
}
